import { LogLevel } from 'public-contracts';
let logLevel = LogLevel.INFO;
let logTarget = 'console';
let api = {
    sendLog: () => { },
    getLogs: () => { },
    info: () => { },
    warn: () => { },
    error: () => { },
    debug: () => { },
    trace: () => { },
};
export const setLogLevel = (level) => {
    logLevel = level;
};
export const setLogTarget = (target) => {
    logTarget = target;
};
export const setApi = (newApi) => {
    api = newApi;
};
export const log = (level, message, stack, metadata) => {
    let logFn;
    if (logTarget === 'console') {
        switch (level) {
            case LogLevel.DEBUG: {
                logFn = console.debug;
                break;
            }
            case LogLevel.INFO: {
                logFn = console.info;
                break;
            }
            case LogLevel.WARN: {
                logFn = console.warn;
                break;
            }
            case LogLevel.ERROR: {
                logFn = console.error;
                break;
            }
            default: {
                logFn = console.info;
                break;
            }
        }
    }
    else {
        switch (level) {
            case LogLevel.DEBUG: {
                logFn = api.debug;
                break;
            }
            case LogLevel.INFO: {
                logFn = api.info;
                break;
            }
            case LogLevel.WARN: {
                logFn = api.warn;
                break;
            }
            case LogLevel.ERROR: {
                logFn = (message, stack, metadata) => api.error(message, stack ?? '', metadata);
                break;
            }
            default: {
                logFn = api.info;
                break;
            }
        }
    }
    if (level >= logLevel) {
        logFn(message, stack, metadata);
    }
};
export const info = (message, metadata) => {
    log(LogLevel.INFO, message, undefined, metadata);
};
export const warn = (message, metadata) => {
    log(LogLevel.WARN, message, undefined, metadata);
};
export const error = (message, stack, metadata) => {
    log(LogLevel.ERROR, message, stack, metadata);
};
export const debug = (message, metadata) => {
    log(LogLevel.DEBUG, message, undefined, metadata);
};
export const trace = (message, stack, metadata) => {
    log(LogLevel.TRACE, message, stack, metadata);
};
//# sourceMappingURL=data:application/json;base64,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